module.exports = __webpack_public_path__ + "public/media/vedio_dxfx.6bc5f8da.mp4";